<template>
  <v-form @submit.prevent="store.listar(true)">
    <sds-page title="Consulta de Pareceres Referenciais">
      <v-row>
        <v-col>
          <sds-card title="Parâmetros da Consulta">
            <template #header-actions>
              <v-btn
                color="primary"
                text
                :to="{ path: '/privado/parecer-referencial/cadastro' }"
                data-testid="btn-new"
              >
                Novo Parecer Referencial
                <v-icon class="ml-2 mt-1"> mdi-plus-circle-outline </v-icon>
              </v-btn>
            </template>
            <v-row dense>
              <v-col cols="5">
                <SdsDateRangeField
                  label="Período da Aprovação:"
                  @change:data-inicial="filter.dtParecerDe = $event"
                  @change:data-final="filter.dtParecerAte = $event"
                />
              </v-col>
              <v-col cols="5" class="pl-3">
                <SdsDateRangeField
                  label="Período de Validade:"
                  @change:data-inicial="filter.dtValidadeDe = $event"
                  @change:data-final="filter.dtValidadeAte = $event"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <sds-input-control
                  label="Número do Processo/Protocolo:"
                  class="d-inline-block"
                >
                  <SdsTextField
                    v-model="filter.nuAnoProcesso"
                    placeholder="aaaa"
                    v-mask="'####'"
                    class="year-field d-inline-block"
                    aria-label="Ano do processo/protocolo:"
                  />
                  <span class="mr-3 ml-3 mb-2 d-inline-block">/</span>
                  <SdsTextField
                    v-model="filter.nuProcesso"
                    placeholder="00000000"
                    v-mask="'########'"
                    class="d-inline-block"
                    aria-label="Número do Processo/Protocolo:"
                  />
                </sds-input-control>
                <sds-input-control
                  label="Número do Parecer:"
                  class="d-inline-block ml-4"
                >
                  <SdsTextField
                    v-model="filter.nuParecer"
                    placeholder="00000000"
                    v-mask="'#########'"
                    class="d-inline-block"
                    aria-label="Número do Parecer:"
                  />
                  <span class="mr-3 ml-3 mb-2 d-inline-block">/</span>
                  <SdsTextField
                    v-model="filter.nuAnoParecer"
                    placeholder="aaaa"
                    v-mask="'####'"
                    class="year-field d-inline-block"
                    aria-label="Ano do Parecer:"
                  />
                </sds-input-control>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <div class="d-flex align-end">
                  <v-checkbox
                    id="municipal"
                    v-model="filter.flMostraInternet"
                    label="Disponível na Web"
                    class="pr-5 mt-0"
                    hide-details
                    :true-value="SimNao.FL_SIM"
                    :false-value="SimNao.FL_NAO"
                    @change="filter.flForaUso = SimNao.FL_NAO"
                  />
                  <v-checkbox
                    v-model="filter.flVencidos"
                    label="Filtrar Somente Vencidos"
                    class="pr-5 mt-0"
                    hide-details
                    :true-value="SimNao.FL_SIM"
                    :false-value="SimNao.FL_NAO"
                  />
                  <v-checkbox
                    v-model="filter.flForaUso"
                    label="Filtrar Somente Inativos"
                    class="mt-0"
                    hide-details
                    :true-value="SimNao.FL_SIM"
                    :false-value="SimNao.FL_NAO"
                    @change="filter.flMostraInternet = SimNao.FL_NAO"
                  />
                </div>
              </v-col>
            </v-row>
            <v-divider class="mt-8 mb-1" />
            <template #actions-right>
              <v-btn text color="primary" @click="reloadPage()"> Limpar </v-btn>
              <v-btn depressed color="primary" class="ml-2" type="submit">
                Consultar
              </v-btn>
            </template>
          </sds-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <sds-card v-show="result.content" title="Resultado da Consulta">
            <v-row dense>
              <v-col cols="12">
                <SdsDataTable
                  v-model="result"
                  :headers="headers"
                  disable-sort
                  @page:change="store.listar()"
                >
                  <template #item.processoCompleto="{ item }">
                    {{
                      getMasckValor(
                        item.nuAnoProcessoOficial,
                        item.nuProcessoOficial,
                        true,
                        true
                      )
                    }}
                  </template>

                  <template #item.parecerCompleto="{ item }">
                    {{
                      getMasckValor(
                        item.nuAnoParecer,
                        item.nuParecer,
                        false,
                        false
                      )
                    }}
                  </template>

                  <template #item.flForaUso="{ item }">
                    <v-chip :color="getColor(item.flForaUso)" dark>
                      {{ item.flForaUso === 'N' ? 'Não' : 'Sim' }}
                    </v-chip>
                  </template>

                  <template #item.flMostraInternet="{ item }">
                    <v-chip :color="getColor(item.flMostraInternet)" dark>
                      {{ item.flMostraInternet === 'N' ? 'Não' : 'Sim' }}
                    </v-chip>
                  </template>

                  <template #item.acao="{ item }">
                    <v-btn
                      icon
                      :to="{
                        path: `/privado/parecer-referencial/cadastro/${item.cdParecerReferencial}`,
                      }"
                    >
                      <v-icon class="mr-1"> mdi-pencil </v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      :href="
                        ParecerReferencialService.getUrlDownload(
                          item.cdParecerReferencial
                        )
                      "
                      target="_blank"
                    >
                      <v-icon>
                        {{ mdiEye }}
                      </v-icon>
                    </v-btn>
                  </template>
                </SdsDataTable>
              </v-col>
            </v-row>
          </sds-card>
        </v-col>
      </v-row>
    </sds-page>
  </v-form>
</template>

<script lang="ts" setup>
import { mdiEye } from '@mdi/js';
import SdsDateRangeField from '@/components/SdsDateRangeField.vue';
import SdsTextField from '@/components/SdsTextField.vue';
import SdsDataTable from '@/components/SdsDataTable.vue';
import { reloadPage } from '@/utils';
import { SimNao } from '@/types/enum/SimNao';
import { useConsultaParecerReferencialStore } from './store/ConsultaParecerReferencialStore';
import { storeToRefs } from 'pinia';
import ParecerReferencialService from './service/ParecerReferencialService';

const store = useConsultaParecerReferencialStore();
const { filter, result } = storeToRefs(store);
const headers = [
  {
    text: 'Processo',
    value: 'processoCompleto',
    align: 'center',
    width: '160px',
  },
  {
    text: 'Parecer',
    value: 'parecerCompleto',
    align: 'center',
    width: '160px',
  },
  {
    text: 'Aprovação da Presidência',
    value: 'dtParecer',
    align: 'center',
    width: '180px',
  },
  {
    text: 'Data Validade',
    value: 'dtValidade',
    align: 'center',
    width: '150px',
  },
  {
    text: 'Inativo',
    value: 'flForaUso',
    align: 'center',
    width: '100px',
  },
  {
    text: 'Disponível na Web',
    value: 'flMostraInternet',
    align: 'center',
    width: '100px',
  },
  {
    text: 'Ação',
    value: 'acao',
    align: 'center',
    width: '120px',
  },
];

const getColor = (valor: SimNao) => {
  return valor === SimNao.FL_NAO ? '#B71D1C' : '#548B2F';
};

const getMasckValor = (
  ano: string,
  numero: string,
  ordem: boolean,
  leftPad: boolean
) => {
  return ordem
    ? ano + '/' + getMasckQtdeCaracter(numero, leftPad)
    : getMasckQtdeCaracter(numero, leftPad) + '/' + ano;
};

const getMasckQtdeCaracter = (valor: string, leftPad: boolean) => {
  if (!leftPad) {
    return valor;
  }
  let valorAtualizado = valor;

  for (let i = valor.length; i < 8; i++) {
    valorAtualizado = 0 + valorAtualizado;
  }

  return valorAtualizado;
};
</script>
